import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-write-articles',
  templateUrl: './write-articles.component.html',
  styleUrls: ['./write-articles.component.scss']
})
export class WriteArticlesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
